import type { SubscriptionTier } from '../types/subscription';

/**
 * Maps API or persisted plan/tier strings to canonical SubscriptionTier values.
 */
const RAW_TO_SUBSCRIPTION_TIER: Record<string, SubscriptionTier> = {
  starter: 'starter',
  up: 'up',
  scale: 'scale',
  a_la_carte: 'a_la_carte',
};

export function normalizeSubscriptionTier(
  raw: string | null | undefined,
  fallback: SubscriptionTier = 'a_la_carte',
): SubscriptionTier {
  if (raw == null || raw === '') {
    return fallback;
  }
  const mapped = RAW_TO_SUBSCRIPTION_TIER[raw.toLowerCase()];
  return mapped ?? fallback;
}
